export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE'
export const USER_LOGGED_IN = 'USER_LOGGED_IN'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'

export const userLogin = user => ({
    type: USER_LOGIN,
    payload: user
})

export const loginFailed = message => ({
    type: USER_LOGIN_FAILURE,
    payload: message
})

export const userLogout = () => ({
    type: USER_LOGOUT
})

export const setAuth = user => ({
    type: USER_LOGGED_IN,
    payload: user
})

export const resetAuth = () => ({
    type: USER_LOGGED_OUT
})